import { render, staticRenderFns } from "./AdditionListSetting.vue?vue&type=template&id=42de9a62"
import script from "./AdditionListSetting.vue?vue&type=script&lang=js"
export * from "./AdditionListSetting.vue?vue&type=script&lang=js"
import style0 from "./AdditionListSetting.vue?vue&type=style&index=0&id=42de9a62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports